<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title Создать заявку
    .profile-page__body
      .profile-page-form
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Данные заявки
          .profile-section__body
            .form
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.shift.value }"
                )
                  .form-elem__title Смена
                  .form-elem__body
                    multiselect.custom-multiselect(
                    v-model="fields.shift"
                    placeholder="Введите название смены",
                    :options="shifts"
                    :label="'name'"
                    :multiple="false"
                    :showLabels="false"
                    :closeOnSelect="true"
                    :allowEmpty="false"
                    @select="shiftSelected"
                    )
                      template(
                      slot="noOptions"
                      ) Список пуст
                      template(
                      slot="noResult"
                      ) Ничего не найдено
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.quota.value }"
                )
                  .form-elem__title Квота
                  .form-elem__body
                    multiselect.custom-multiselect(
                    v-model="fields.quota"
                    placeholder="Введите название квоты",
                    :options="quotas"
                    :label="'name'"
                    :multiple="false"
                    :showLabels="false"
                    :closeOnSelect="true"
                    :allowEmpty="false"
                    :disabled="quotaSelectDisabled"
                    @select="quotaSelected"
                    )
                      template(
                      slot="noOptions"
                      ) Список пуст
                      template(
                      slot="noResult"
                      ) Ничего не найдено
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.house.value }"
                )
                  .form-elem__title Корпус
                  .form-elem__body
                    multiselect.custom-multiselect(
                    v-model="fields.house"
                    placeholder="Введите название корпуса",
                    :options="houses"
                    :label="'name'"
                    :multiple="false"
                    :showLabels="false"
                    :closeOnSelect="true"
                    :allowEmpty="false"
                    :disabled="houseSelectDisabled"
                    @select="resetError('house')"
                    )
                      template(
                      slot="noOptions"
                      ) Список пуст
                      template(
                      slot="noResult"
                      ) Ничего не найдено
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Данные ребенка
          .profile-section__body
            .form
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.lastName.value }"
                )
                  .form-elem__title Фамилия ребенка
                  .form-elem__body
                    input.input.input_full.input_capitalize(
                    v-model="fields.lastName"
                    v-on:keyup="resetError('lastName')"
                    )
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.firstName.value }"
                )
                  .form-elem__title Имя ребенка
                  .form-elem__body
                    input.input.input_full.input_capitalize(
                    v-model="fields.firstName"
                    v-on:keyup="resetError('firstName')"
                    )
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.fathersName.value }"
                )
                  .form-elem__title Отчество ребенка
                  .form-elem__body
                    input.input.input_full.input_capitalize(
                    v-model="fields.fathersName"
                    v-on:keyup="resetError('fathersName')"
                    )
              .form__elem.form__elem_short
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.dateOfBirth.value }"
                )
                  .form-elem__title Дата рождения ребенка
                  .form-elem__body
                    date-picker(
                    placeholder="дд.мм.гггг"
                    v-model="fields.dateOfBirth"
                    format="DD.MM.YYYY"
                    :value-type="'format'"
                    lang="ru"
                    input-class="input input_full"
                    @change="resetError('dateOfBirth')"
                    :clearable="false"
                    :editable="true"
                    :not-after="new Date()"
                    )
                    //format="DD.MM.YYYY"
              //.form__elem
              //  .form-elem.form-elem_horizontal(
              //  :class="{ 'form-elem_error' : fieldsErrors.address.value }"
              //  )
              //    .form-elem__title Адрес регистрации ребенка
              //    .form-elem__body
              //      input.input.input_full(
              //      v-model="fields.address"
              //      v-on:keyup="resetError('address')"
              //      )
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.inn.value }"
                )
                  .form-elem__title ИНН ребенка
                  .form-elem__body
                    input.input.input_full(
                    v-model="fields.inn"
                    v-on:keyup="resetError('inn')"
                    ref="inn"
                    )
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.snils.value }"
                )
                  .form-elem__title СНИЛС ребенка
                  .form-elem__body
                    input.input.input_full(
                    v-model="fields.snils"
                    v-on:keyup="resetError('snils')"
                    ref="snils"
                    )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Адрес регистрации ребенка
          .profile-section__body
            form-address(
            :address="fields.address"
            :field="'address'"
            @on-change-value="onChangeAddressField"
            :require-errors="addressFieldsErrors"
            )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Данные родителя
          .profile-section__body
            .form
              .form__elem
                .form-elem.form-elem_horizontal(
                :class="{ 'form-elem_error' : fieldsErrors.email.value }"
                )
                  .form-elem__title Email
                  .form-elem__body
                    input.input.input_full(
                    v-model="fields.email"
                    v-on:keyup="resetError('email')"
                    )
        section.profile-page-form__section.profile-section
          .profile-section__body
            .form
              .form__elem.form__elem_button
                .form-elem
                  .form-elem__body
                    button.button.button_paint-main.button_long(
                    @click.prevent="onCreateRequest"
                    ) Создать заявку
                  .form-elem__error(
                    v-if="currentErrorMessage.length > 0"
                  ) {{currentErrorMessage}}

</template>

<script>
import {mapState, mapActions} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import Inputmask from "inputmask";
import FormAddress from "../../../profile/components/forms/FormAddress";

export default {
  name: "ManagerCreateRequest",
  components: {
    FormAddress,
    Multiselect,
    DatePicker
  },
  data() {
    return {
      fields: {
        shift: {
          name: "Выберите смену",
          id: null
        },
        quota: {
          name: "Выберите квоту",
          id: null
        },
        house: {
          name: "Выберите корпус",
          id: null
        },
        lastName: "",
        firstName: "",
        fathersName: "",
        dateOfBirth: "",
        // address: "",
        inn: "",
        snils: "",
        email: "",
        address: {
          region: "",
          area: "",
          city: "",
          street: "",
          house: "",
          apartment: "",
          postal_code: ""
        }
      },
      fieldsErrors: {
        shift: {
          value: false,
          message: "Выберите смену"
        },
        quota: {
          value: false,
          message: "Выберите квоту"
        },
        house: {
          value: false,
          message: "Выберите корпус"
        },
        lastName: {
          value: false,
          message: "Введите фамилию"
        },
        firstName: {
          value: false,
          message: "Введите имя ребенка"
        },
        fathersName: {
          value: false,
          message: "Введите отчество ребенка"
        },
        dateOfBirth: {
          value: false,
          message: "Введите дату рождения ребенка"
        },
        address: {
          value: false,
          message: "Введите адрес регистрации ребенка"
        },
        inn: {
          value: false,
          message: "Введите ИНН ребенка"
        },
        snils: {
          value: false,
          message: "Введите СНИЛС ребенка"
        },
        email: {
          value: false,
          message: "Введите email"
        }
      },
      addressFieldsErrors: {
        "address.region": false,
        "address.area": false,
        "address.city": false,
        "address.street": false,
        "address.house": false,
        "address.postal_code": false
      },
      quotas: [],
      houses: [],
      currentErrorMessage: "",
      innMask: new Inputmask({
        placeholder: "____________",
        allowMinus: false,
        rightAlign: false,
        mask: "999999999999",
        showMaskOnHover: false,
        showMaskOnFocus: false
      }),
      snilsMask: new Inputmask({
        placeholder: "___-___-___ __",
        allowMinus: false,
        rightAlign: false,
        mask: "999-999-999 99",
        showMaskOnHover: false,
        showMaskOnFocus: false
      })
    };
  },
  computed: {
    ...mapState(["managerShifts"]),
    shifts() {
      let otherShifts = [];
      if (this.managerShifts) {
        otherShifts = this.managerShifts.map(item => {
          return {
            name: item.name,
            id: item.id
          };
        });
      }
      return otherShifts;
    },
    quotaSelectDisabled() {
      if (this.fields.shift.id) {
        return false;
      }
      return true;
    },
    houseSelectDisabled() {
      if (this.fields.quota.id) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      "getShifts",
      "getQuotas",
      "getQuotasHouses",
      "createOffOrder"
    ]),
    shiftSelected(selectedOption) {
      this.fields.quota = {
        name: "Выберите квоту",
        id: null
      };
      this.fields.house = {
        name: "Выберите корпус",
        id: null
      };
      this.resetError("shift");
      this.getQuotas({
        campshift: selectedOption.id
      }).then(res => {
        this.quotas = res;
      });
    },
    quotaSelected(selectedOption) {
      this.fields.house = {
        name: "Выберите корпус",
        id: null
      };
      this.resetError("quota");
      this.getQuotasHouses({
        quota: selectedOption.id
      }).then(res => {
        this.houses = res.map(item => {
          return {
            name: item.house_name,
            id: item.id
          };
        });
      });
    },
    resetError(field) {
      this.currentErrorMessage = "";
      this.fieldsErrors[field].value = false;
    },
    onChangeAddressField(field, item, val) {
      this.fields[field][item] = val;
      this.addressFieldsErrors[`${field}.${item}`] = false;
    },
    onChangeDate(e) {

    },
    validation() {
      const errors = [];

      const fieldsWithId = [
        "shift",
        "quota",
        "house"
      ];

      const stringFields = [
        "lastName",
        "firstName",
        "fathersName",
        // "dateOfBirth",
        // "address",
        // "inn",
        "snils"
      ];

      const addressFields = [
        "region",
        "area",
        "city",
        "street",
        "house",
        "postal_code"
      ];

      fieldsWithId.forEach(item => {
        if (!this.fields[item].id) {
          errors.push(item);
          this.fieldsErrors[item].value = true;
        }
      });

      stringFields.forEach(item => {
        if (this.fields[item].length === 0) {
          errors.push(item);
          this.fieldsErrors[item].value = true;
        }
      });

      addressFields.forEach(item => {
        if (this.fields.address[item].length === 0) {
          errors.push("address");
          this.addressFieldsErrors[`address.${item}`] = true;
        }
      });

      const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.fields.email.length === 0 || !emailReg.test(this.fields.email)) {
        errors.push("email");
        this.fieldsErrors.email.value = true;
      }

      if (errors.length > 0) {
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onCreateRequest() {
      if (!this.validation()) {
        return false;
      }
      const snils = this.fields.snils.replace("-", "");
      const date = this.fields.dateOfBirth.length > 0 ? this.fields.dateOfBirth.split(".").reverse().join("-") : null;
      const data = {
        quotashouse: this.fields.house.id,
        first_name: this.fields.firstName,
        fathers_name: this.fields.fathersName,
        last_name: this.fields.lastName,
        inn: this.fields.inn,
        snils: snils,
        date_of_birth: date,
        registration_address: this.fields.address,
        email: this.fields.email
      };
      this.createOffOrder(data).then(res => {
        if (res.status === 201) {
          this.$root.$emit("onShowNotificationModal", {
            text:
              "Заявка создана"
          });
        } else if (res.data.order.code === 6) {
          this.$root.$emit("onShowErrorModal", {
            text: res.data.order.message
          });
        } else {
          console.log(res);
          this.$root.$emit("onShowErrorModal", {
            text: "Ошибка " + res.status
          });
        }
      });
    }
  },
  mounted() {
    this.snilsMask.mask(this.$refs.snils);
    this.innMask.mask(this.$refs.inn);
    if (!this.managerShifts) {
      this.getShifts();
    }
  }

};
</script>
